import React from 'react';
import styled from 'styled-components';

import Link from 'components/Link';
import Container from 'components/Container';
import Text from 'components/Text';

import { color } from 'styles/utils';

const Section = styled.section`
  background-color: ${color('bgBlueGray')};
  padding: 4.5rem 1.5rem;
  a {
    color: ${color('teal')};
    text-decoration: underline;
  }
`;

const StyledParagraph = styled(Text)`
  padding-bottom: 1.5rem;
`;

const StyledList = styled(Text)`
  padding-left: 1.5rem;
  padding-bottom: 1.5rem;
  li {
    padding-left: 0.5rem;
  }
`;

const StyledHeader = styled(Text)`
  padding-bottom: 1rem;
`;

export default function Content() {
  return (
    <Section>
      <Container size="sm">
        <StyledParagraph variant="p">
          The Company (Sleuth Enterprises, Inc.) ("us", "we", or "our") operates{' '}
          <Link href="/">https://sleuth.io</Link> (the "Site"). This page
          informs you of our policies regarding the collection, use and
          disclosure of Personal Information we receive from users of the Site.
          We use your Personal Information only for providing and improving the
          Site. By using the Site, you agree to the collection and use of
          information in accordance with this policy.
        </StyledParagraph>

        <StyledHeader variant="f4">Information Collection And Use</StyledHeader>
        <StyledParagraph variant="p">
          While using our Site, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you. Personally identifiable information may include, but is
          not limited to:
        </StyledParagraph>
        <StyledList forwardedAs="ul" variant="p">
          <li>your name, company, email address, billing address</li>
          <li>your Sleuth user ID and password</li>
          <li>credit card information</li>
          <li>any account-preference information you provide us</li>
          <li>
            your computer's domain name and IP address, indicating where your
            computer is located on the Internet
          </li>
          <li>session data for your login session</li>
          <li>
            information provided to us about your Git/Hg repositories hosted on
            external sites
          </li>
        </StyledList>
        <StyledParagraph variant="p">
          If you do provide us with personally identifiable information we will:
        </StyledParagraph>
        <StyledList forwardedAs="ul" variant="p">
          <li>not sell or rent it to a third party without your permission</li>
          <li>
            take commercially reasonable precautions to protect the information
            from loss, misuse and unauthorized access, disclosure, alteration
            and destruction
          </li>
        </StyledList>

        <StyledHeader variant="f4">Security</StyledHeader>
        <StyledParagraph variant="p">
          The security of your Personal Information is important to us, but
          remember that no method of transmission over the Internet, or method
          of electronic storage, is 100% secure. While we strive to use
          commercially acceptable means to protect your Personal Information, we
          cannot guarantee its absolute security.
        </StyledParagraph>

        <StyledHeader variant="f4">Communications</StyledHeader>
        <StyledParagraph variant="p">
          We may use your Personal Information to contact you with newsletters,
          marketing or promotional materials. You'll have the ability to opt-out
          of any of these materials by unsubscribing.
        </StyledParagraph>

        <StyledHeader variant="f4">Handling Payments</StyledHeader>
        <StyledParagraph variant="p">
          Payment processing services enable this Application to process
          payments by credit card, bank transfer or other means. To ensure
          greater security, this Application shares only the information
          necessary to execute the transaction with the financial intermediaries
          handling the transaction. Some of these services may also enable the
          sending of timed messages to the User, such as emails containing
          invoices or notifications concerning the payment.
        </StyledParagraph>
        <StyledParagraph variant="p">
          Stripe (Stripe Inc)Stripe is a payment service provided by Stripe Inc.
        </StyledParagraph>
        <StyledParagraph variant="p">
          Personal Data collected: Various types of Data as specified in the
          privacy policy of the service.
        </StyledParagraph>
        <StyledParagraph variant="p">
          Place of processing: USA -{' '}
          <Link href="https://stripe.com/privacy">Privacy Policy</Link>
        </StyledParagraph>

        <StyledHeader variant="f4">Cookies</StyledHeader>
        <StyledParagraph variant="p">
          Cookies are files with small amount of data, which may include an
          anonymous unique identifier. Cookies are sent to your browser from a
          web site and stored on your computer's hard drive. Like many sites, we
          use "cookies" to collect information. You can instruct your browser to
          refuse all cookies or to indicate when a cookie is being sent.
          However, if you do not accept cookies, you may not be able to use some
          portions of our Site.
        </StyledParagraph>

        <StyledHeader variant="f4">Log Data</StyledHeader>
        <StyledParagraph variant="p">
          Like many site operators, we collect information that your browser
          sends whenever you visit our Site ("Log Data"). This Log Data may
          include information such as your computer's Internet Protocol ("IP")
          address, browser type, browser version, the pages of our Site that you
          visit, the time and date of your visit, the time spent on those pages
          and other statistics. In addition, we may use third party services
          such as Google Analytics that collect, monitor and analyze this data.
        </StyledParagraph>

        <StyledHeader variant="f4">California Residents</StyledHeader>
        <StyledParagraph variant="p">
          California Civil Code Section 1798.83 requires certain businesses that
          share customer Personal Information with third parties for the third
          parties' direct marketing purposes to respond to requests from
          California customers asking about the businesses' practices related to
          such information-sharing. We currently do not share or disclose your
          Personal Information to third parties for the third parties' direct
          marketing purposes. If we change our practices in the future, we will
          implement an opt-out policy as required under California laws.
        </StyledParagraph>
        <StyledParagraph variant="p">
          Furthermore, subject to certain exemptions, California residents have
          the following rights with respect to Personal Information we may have
          collected about them:
        </StyledParagraph>

        <StyledHeader variant="f4">Requests to Know</StyledHeader>
        <StyledParagraph variant="p">
          You have the right to request that we disclose:
        </StyledParagraph>
        <StyledList forwardedAs="ul" variant="p">
          <li>
            The categories of Personal Information we have collected about you;
          </li>
          <li>
            The categories of Personal Information about you we have sold or
            disclosed for a business purpose;
          </li>
          <li>
            The categories of sources from which we have collected Personal
            Information about you;
          </li>
          <li>
            The business or commercial purposes for selling or collecting
            Personal Information about you;
          </li>
          <li>
            The categories of Personal Information sold or shared, if any, about
            you, as well as the categories of third parties to whom the Personal
            Information was sold, by category of Personal Information for each
            party to whom Personal Information was sold; and
          </li>
          <li>The specific pieces of Personal Information collected.</li>
        </StyledList>
        <StyledParagraph variant="p">
          You may submit a request to know via our{' '}
          <Link to="/request-for-personal-information/">
            Personal Information request form
          </Link>
          . The delivery of our response may take place electronically or by
          mail. We are not required to respond to requests to know more than
          twice in a 12-month period.
        </StyledParagraph>
        <StyledParagraph variant="p">
          We do not sell, and have not in the prior 12 months sold, Personal
          Information about California residents. Therefore, we have not
          included a “Do Not Sell My Personal Info” link on our Site. If our
          practices change, we will update this Privacy Policy and take any
          other necessary action to comply with applicable law. We do, however,
          disclose Personal Information for business purposes as described in
          the “Third Parties We Share Personal Information With” section above.
        </StyledParagraph>

        <StyledHeader variant="f4">Requests to Delete</StyledHeader>
        <StyledParagraph variant="p">
          You have the right to request that we delete any Personal Information
          about you that we have collected. Upon receiving a verified request to
          delete Personal Information, we will do so unless otherwise required
          or authorized by law. You may submit a request to delete Personal
          Information via our{' '}
          <Link to="/request-for-personal-information/">
            Personal Information request form
          </Link>
          .
        </StyledParagraph>

        <StyledHeader variant="f4">Authorized Agents</StyledHeader>
        <StyledParagraph variant="p">
          You may designate an authorized agent to make requests on your behalf.
          You must provide an authorized agent written permission to submit a
          request on your behalf, and we may require that you verify your
          identity directly with us. Alternatively, an authorized agent that has
          been provided power of attorney pursuant to Probate Code sections
          4000-4465 may submit a request on your behalf.
        </StyledParagraph>

        <StyledHeader variant="f4">
          Methods for Submitting Consumer Requests and Our Response to Requests
        </StyledHeader>
        <StyledParagraph variant="p">
          You may submit a request for access and requests to delete Personal
          Information about you via:
        </StyledParagraph>
        <StyledList forwardedAs="ul" variant="p">
          <li>
            <Link to="/request-for-personal-information/">
              Personal Information request form
            </Link>
            , or
          </li>
          <li>
            via email at{' '}
            <Link href="mailto:support@sleuth.io">support@sleuth.io</Link>
          </li>
        </StyledList>
        <StyledParagraph variant="p">
          Upon receipt of a request, we may ask you for additional information
          to verify your identity. Any additional information you provide will
          be used only to verify your identity and not for any other purpose.
        </StyledParagraph>
        <StyledParagraph variant="p">
          We will acknowledge the receipt of your request within 10 days of
          receipt. Subject to our ability to verify your identity, we will
          respond to your request within 45 days of receipt. If we require more
          time (up to 90 days), we will inform you of the reason and extension
          period in writing. In order to protect your privacy and the security
          of Personal Information about you, we may need to verify your identity
          before processing your request. In some cases we may need to collect
          additional information to verify your identity, such as a government
          issued ID.
        </StyledParagraph>
        <StyledParagraph variant="p">
          Any disclosures we provide will only cover the 12-month period
          preceding the verifiable consumer request's receipt. The response we
          provide will also explain the reasons we cannot comply with a request,
          if applicable.
        </StyledParagraph>
        <StyledParagraph variant="p">
          We do not charge a fee to process or respond to your verifiable
          consumer request unless it is excessive, repetitive, or manifestly
          unfounded. If we determine that the request warrants a fee, we will
          tell you why we made that decision and provide you with a cost
          estimate before completing your request.
        </StyledParagraph>

        <StyledHeader variant="f4">
          The Right to Non-Discrimination
        </StyledHeader>
        <StyledParagraph variant="p">
          You have the right not to be discriminated against for the exercise of
          your California privacy rights described above. Unless permitted by
          the CCPA, we will not:
        </StyledParagraph>
        <StyledList forwardedAs="ul" variant="p">
          <li>Deny you goods or services;</li>
          <li>
            Charge you different prices or rates for goods or services,
            including through granting discounts or other benefits, or imposing
            penalties;
          </li>
          <li>
            Provide you a different level or quality of goods or services; or
          </li>
          <li>
            Suggest that you may receive a different price or rate for goods or
            services or a different level or quality of goods or services.
          </li>
        </StyledList>

        <StyledHeader variant="f4">Changes To This Privacy Policy</StyledHeader>
        <StyledParagraph variant="p">
          This Privacy Policy is effective as of November 28, 2019 and will
          remain in effect except with respect to any changes in its provisions
          in the future, which will be in effect immediately after being posted
          on this page. We reserve the right to update or change our Privacy
          Policy at any time and you should check this Privacy Policy
          periodically. Your continued use of the Service after we post any
          modifications to the Privacy Policy on this page will constitute your
          acknowledgment of the modifications and your consent to abide and be
          bound by the modified Privacy Policy. If we make any material changes
          to this Privacy Policy, we will notify you either through the email
          address you have provided us, or by placing a prominent notice on our
          website.
        </StyledParagraph>

        <StyledHeader variant="f4">Contact Us</StyledHeader>
        <StyledParagraph variant="p">
          If you have any questions about this Privacy Policy, please contact us
          via email at{' '}
          <Link href="mailto:support@sleuth.io">support@sleuth.io</Link>.
        </StyledParagraph>
      </Container>
    </Section>
  );
}
